<template>
  <div class="row">
    <div class="col-6">
      <b-form-group label="Zona horaria">
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="timezones"
          class="w-100 datetime-select"
          :reduce="(val) => val.value"
          v-model="itemData.timezone"
          append-to-body
          :clearable="false"
          :disabled="loading"
          :calculate-position="withPopper"
        />
      </b-form-group>
    </div>
    <div class="col-6">
      <b-form-group label="Idioma">
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="langs"
          class="w-100 datetime-select"
          :reduce="(val) => val.value"
          v-model="itemData.newLanguage"
          append-to-body
          :disabled="loading"
          :clearable="false"
          :calculate-position="withPopper"
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import popperHelper from "@/libs/popper-helper";
import vSelect from "vue-select";

export default {
  props:{
    itemData:{
      type: Object
    },
    langs: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    timezones: {
      type: Array
    }
  },
  components: {
    vSelect
  },
  setup () {
    return { withPopper: popperHelper.withPopper }
  }
}
</script>
